"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfigurationProvider = exports.ConfigurationContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Funnel = require("../../components/Funnel");

var _ViewContainer = _interopRequireDefault(require("../../components/ViewContainer"));

var _FooterNavigation = _interopRequireDefault(require("../../components/FooterNavigation"));

var _SingleChoice = require("../../components/SingleChoice");

var _useOurTranslation = _interopRequireDefault(require("../../utils/useOurTranslation"));

var _FunnelHeader = _interopRequireDefault(require("../../components/FunnelHeader"));

var _LegalFooter = _interopRequireDefault(require("../../components/LegalFooter"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-check
var ConfigurationContext = /*#__PURE__*/_react.default.createContext({
  loadableConfigs: {},
  configurationLoaded: false,
  loadConfiguration: function loadConfiguration() {}
});
/**
 * Provider that holds the applications config. A config is mandatory for the application to run.
 * This Provider wont render children if no config is present
 */


exports.ConfigurationContext = ConfigurationContext;

var ConfigurationProvider = function ConfigurationProvider(_ref) {
  var config = _ref.config,
      loadableConfigs = _ref.loadableConfigs,
      preselection = _ref.preselection,
      children = _ref.children,
      header = _ref.header,
      _ref$translateNs = _ref.translateNs,
      translateNs = _ref$translateNs === void 0 ? 'profile-components:ChooseConfig' : _ref$translateNs,
      sections = _ref.sections,
      onCancel = _ref.onCancel,
      onConfiguredConfirm = _ref.onConfiguredConfirm,
      buttonLeftText = _ref.buttonLeftText,
      actionButton = _ref.actionButton,
      applicationRoutes = _ref.applicationRoutes;

  var _useState = (0, _react.useState)(config),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loadedConfig = _useState2[0],
      loadConfig = _useState2[1];

  var _useState3 = (0, _react.useState)(loadedConfig || (typeof preselection !== 'undefined' && typeof loadableConfigs !== 'undefined' ? loadableConfigs[preselection] : undefined)),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      choosenConfig = _useState4[0],
      chooseConfig = _useState4[1];

  var configurationLoaded = (0, _react.useMemo)(function () {
    return !!loadedConfig && !!loadedConfig.discriminator;
  }, [loadedConfig]);
  var state = (0, _react.useMemo)(function () {
    return {
      config: loadedConfig,
      loadableConfigs: loadableConfigs,
      configurationLoaded: configurationLoaded,
      loadConfiguration: function loadConfiguration(config) {
        if (config && onConfiguredConfirm) {
          onConfiguredConfirm(config).then(function (confirmed) {
            if (confirmed) {
              loadConfig(config);
            } else {
              chooseConfig(typeof preselection !== 'undefined' && typeof loadableConfigs !== 'undefined' ? loadableConfigs[preselection] : undefined);
              loadConfig(undefined);
            }
          });
        } else {
          loadConfig(config);
        }
      }
    };
  }, [configurationLoaded, loadableConfigs, loadedConfig, onConfiguredConfirm, preselection]);
  var tFunnel = (0, _useOurTranslation.default)("profile-components:Funnel");

  var loadChoosenConfig = function loadChoosenConfig() {
    return state.loadConfiguration(choosenConfig);
  };

  var ChooseConfig = function ChooseConfig() {
    var context = {
      discriminator: {
        value: (choosenConfig === null || choosenConfig === void 0 ? void 0 : choosenConfig.discriminator) || '',
        valueType: 'string',
        touched: false
      }
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [header ? header : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FunnelHeader.default, {
        discriminator: (loadedConfig === null || loadedConfig === void 0 ? void 0 : loadedConfig.discriminator) || 'jmm',
        target: loadedConfig === null || loadedConfig === void 0 ? void 0 : loadedConfig.target,
        actionButton: actionButton
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Funnel.FunnelWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ViewContainer.default, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleChoice.SingleChoiceComponent, {
            config: {
              mandatory: true,
              component: 'SingleChoice',
              valueName: 'discriminator',
              valueType: 'String',
              translations: {
                text: "".concat(translateNs, ".text")
              },
              options: Object.fromEntries(Object.entries(loadableConfigs || {}).map(function (_ref2) {
                var _ref3 = (0, _slicedToArray2.default)(_ref2, 1),
                    k = _ref3[0];

                return [k, "".concat(translateNs, ".options.").concat(k)];
              })),
              sections: sections
            },
            setValue: function setValue(_, discriminator) {
              if (loadableConfigs && loadableConfigs[discriminator]) {
                return chooseConfig(loadableConfigs[discriminator]);
              } else {
                throw Error("Config for discriminator ".concat(discriminator, " can not be loaded, since it is not present in loadableConfigs"));
              }
            },
            context: context
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LegalFooter.default, {
            applicationRoutes: applicationRoutes
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FooterNavigation.default, {
          highlightRightButton: (choosenConfig === null || choosenConfig === void 0 ? void 0 : choosenConfig.discriminator) !== preselection,
          rightButtonDisabled: (choosenConfig === null || choosenConfig === void 0 ? void 0 : choosenConfig.discriminator) === preselection,
          hideLeftButton: !onCancel,
          onRightButtonClick: loadChoosenConfig,
          buttonRightText: tFunnel('next'),
          buttonLeftText: buttonLeftText ? buttonLeftText : tFunnel('back'),
          onLeftButtonClick: typeof onCancel === 'undefined' ? function () {
            return null;
          } : onCancel
        })]
      })]
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ConfigurationContext.Provider, {
    value: state,
    children: configurationLoaded ? children : /*#__PURE__*/(0, _jsxRuntime.jsx)(ChooseConfig, {})
  });
};

exports.ConfigurationProvider = ConfigurationProvider;
var _default = ConfigurationProvider;
exports.default = _default;